/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosDefiProtocolListRequest = {
    sort?: AptosDefiProtocolListRequest.sort;
    direction?: AptosDefiProtocolListRequest.direction;
    page?: number;
    size?: number;
};

export namespace AptosDefiProtocolListRequest {

    export enum sort {
        CATEGORY = 'CATEGORY',
        TVL = 'TVL',
        TVL_CHANGE_1D = 'TVL_CHANGE_1D',
        TVL_CHANGE_7D = 'TVL_CHANGE_7D',
        TVL_CHANGE_30D = 'TVL_CHANGE_30D',
        MCAP_N_TVL = 'MCAP_N_TVL',
    }

    export enum direction {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

